/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-03-05 10:41:10
 * @LastEditors: changfeng
 * @LastEditTime: 2024-03-07 15:22:00
 */

import http from "@/api";

/**
 * @name 登录模块
 */
// * 用户登录接口
export const getCurrentUser = () => {
	return http.get(`/admin/user/current`);
};

export const updateLocale = (data: {
	locale: string;
}) => {
	return http.post(`/admin/user/update/locale`, data);
}
